(function () {
  if (window.__ratingScrollToReviewsInited) return;
  window.__ratingScrollToReviewsInited = true;

  function getStickyOffset() {
    var sticky = document.querySelector('#sticky-header-content');
    if (sticky && sticky.offsetHeight) return sticky.offsetHeight;
    var header = document.querySelector('header.sticky-header-content, header.sticky-header-active, header');
    return header && header.offsetHeight ? header.offsetHeight : 0;
  }

  function scrollTo(target, alignBottom) {
    if (!target) return;
    var rect = target.getBoundingClientRect();
    var edge = alignBottom ? rect.bottom : rect.top;
    var top = edge + window.scrollY - getStickyOffset() - 12;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function findTarget(tab) {
    return (
      document.querySelector('.jdgm-review-content__body-content') ||
      document.querySelector('.jdgm-rev-widg') ||
      document.getElementById('product-reviews') ||
      (tab && tab.closest('.x-block-tab-titles')) ||
      tab
    );
  }

  function activateAndScroll() {
    var tab = document.querySelector('[data-product-reviews-tab]');
    if (tab) tab.click();

    requestAnimationFrame(function () {
      scrollTo(findTarget(tab));
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.js-rating-scroll');
    if (!trigger) return;
    e.preventDefault();
    activateAndScroll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var trigger = e.target.closest && e.target.closest('.js-rating-scroll');
    if (!trigger) return;
    e.preventDefault();
    activateAndScroll();
  });
})();
